export default "  <footer class=\"content-footer\">\r\n                © {{currentYear}} Dealer Awards Program. All Rights Reserved.\r\n            </footer>"